import { useFormContext } from "react-hook-form";

import { Label } from "@fronterahealth/frontera-ui-components";

import { FormInputField } from "@components/AssessmentFormRenderer/components/FormInputField";
import { TextFieldSection } from "@components/AssessmentFormRenderer/types/layoutTypes";
import { getNestedError } from "@components/AssessmentFormRenderer/utils/getNestedError";

interface FormTextFieldProps {
  section: TextFieldSection;
}

export const FormTextField: React.FC<FormTextFieldProps> = ({ section }) => {
  const { formState } = useFormContext();
  const error = getNestedError(formState.errors, section.key);
  const inputType = section.validation?.inputType ?? "text";

  return (
    <div className="flex flex-col">
      <Label>{section.label}</Label>
      <FormInputField
        fieldPath={section.key}
        inputType={inputType}
        editable={section.editable ?? true}
        error={error}
        validation={section.validation}
      />
    </div>
  );
};
